import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { Modal, Form, Row, Col, Input, Button, Select } from 'antd';
@inject('indexManagementStore', 'homeStore')
@observer
class FormModal extends Component {
  state = {
  }
  formRef = React.createRef();
  componentDidMount() {
    const { indexManagementStore, title } = this.props
    const { detailsObj } = indexManagementStore
    if (title === 'edit') {
      this.formRef.current.setFieldsValue({
        groupName: detailsObj.groupName,
        indexIds: Array.from(detailsObj.indexIds),
      })
    }
  }
  handleOk = () => {
    const { indexManagementStore, handleCancel, title } = this.props
    const { detailsObj } = indexManagementStore
    this.formRef.current.validateFields().then(fieldsValue => {
      if (title === 'edit') {
        fieldsValue.id = detailsObj.id
        indexManagementStore.onEditGroupAction(fieldsValue)
      } else {
        indexManagementStore.onAddGroupnAction(fieldsValue)
      }
      handleCancel()
    }).catch(err => { })

  }
  render() {
    const { indexManagementStore, addModalVisible, handleCancel, title } = this.props
    const { indexNameList } = indexManagementStore
    return (
      <>
        <Modal
          title={title === 'edit' ? "Edit Index Group Set" : "Add Index Group Set"}
          closable={false}
          visible={addModalVisible}
          // onOk={this.handleOk}
          // onCancel={handleCancel}
          maskClosable={false}
          destroyOnClose={true}
          centered
          footer={[
            <Button key="Save" type='primary' onClick={this.handleOk}>Save</Button>,
            <Button key="Cancel" onClick={handleCancel}>Cancel</Button>,
          ]}
        >
          <Form ref={this.formRef} key='addMapping'>
            <Row justify='start' gutter={[10, 10]}>
              <Col xs={24} sm={24} md={24} span={24} >
                <Form.Item name='groupName' label="Index Set Name" labelCol={{ span: 8 }} wrapperCol={{ span: 14 }}
                  rules={[{ required: true, message: 'Please enter Index Set Name without special characters.', pattern: new RegExp(/^[^&|;\\\s][^&|;\\]*$/) }]}>
                  <Input maxLength={100} placeholder="Please enter ..." disabled={title === 'edit'} />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={24} span={24} >
                <Form.Item name='indexIds' label="Index Name" labelCol={{ span: 8 }} wrapperCol={{ span: 14 }} rules={[{ required: true, message: 'Please select Index Name.' }]}>
                  <Select placeholder="Please select ..." allowClear showArrow mode="multiple" maxTagCount='responsive' maxTagTextLength={20}>
                    {indexNameList.length > 0 ? indexNameList.map(item => <Select.Option key={item.indexName} value={item.id}>{item.indexName}</Select.Option>) : null}
                  </Select>
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </Modal>
      </>
    );
  }
}

export default FormModal;
